import { Skeleton } from "@heroui/react";

const ChatterSkeleton = () => {
    return (
        <div className="bg-secondary rounded-md p-4">
            <Skeleton className="w-1/3 h-6 rounded-md mb-4">
                <div className="h-6 bg-default-300"></div>
            </Skeleton>
            <Skeleton className="h-16 w-full rounded-lg mb-4">
                <div className="h-16 w-full bg-default-300"></div>
            </Skeleton>
            <div className="flex items-center gap-2">
                <Skeleton className="w-3/4 h-10 rounded-md">
                    <div className="h-10 w-3/4 bg-default-200"></div>
                </Skeleton>
            </div>
        </div>
    )
}

export default ChatterSkeleton;
